"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PatientListFilterSchema () {
        return PatientListFilterSchema;
    },
    get PatientListItemSchema () {
        return PatientListItemSchema;
    },
    get PatientSearchRequestSchema () {
        return PatientSearchRequestSchema;
    },
    get PatientSearchResponseSchema () {
        return PatientSearchResponseSchema;
    },
    get PhilHealthPinSchema () {
        return PhilHealthPinSchema;
    }
});
const _zod = require("zod");
const _patientalert = require("./patient-alert");
const PhilHealthPinSchema = _zod.z.string().regex(/^\d{2}-\d{9}-\d$/);
const PatientListFilterSchema = _zod.z.union([
    _zod.z.enum([
        'all',
        'needs_fpe',
        'provisional_fpe',
        'missing_pin'
    ]),
    _patientalert.PatientAlertSchema
]);
const PatientSearchRequestSchema = _zod.z.object({
    query: _zod.z.string().trim().max(100).optional(),
    filter: PatientListFilterSchema.default('all'),
    page: _zod.z.number().int().min(1).max(10_000).default(1),
    pageSize: _zod.z.literal(50).default(50)
}).strict();
const PatientListItemSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    givenName: _zod.z.string(),
    middleName: _zod.z.string().nullable(),
    familyName: _zod.z.string(),
    sex: _zod.z.enum([
        'F',
        'M'
    ]),
    birthDate: _zod.z.string().date(),
    mrn: _zod.z.string(),
    philhealthPin: PhilHealthPinSchema.nullable(),
    alerts: _zod.z.array(_patientalert.PatientAlertSchema),
    hasAllergies: _zod.z.boolean(),
    lastVisitAt: _zod.z.string().datetime({
        offset: true
    }).nullable(),
    fpeRecordedAt: _zod.z.string().datetime({
        offset: true
    }).nullable()
});
const PatientSearchResponseSchema = _zod.z.object({
    items: _zod.z.array(PatientListItemSchema),
    page: _zod.z.number().int().min(1),
    pageSize: _zod.z.number().int(),
    total: _zod.z.number().int().min(0),
    totalUnfiltered: _zod.z.number().int().min(0)
});
